import { render, staticRenderFns } from "./app-badge.vue?vue&type=template&id=60a39f64&scoped=true&"
import script from "./app-badge.vue?vue&type=script&lang=js&"
export * from "./app-badge.vue?vue&type=script&lang=js&"
import style0 from "./app-badge.vue?vue&type=style&index=0&id=60a39f64&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a39f64",
  null
  
)

export default component.exports